import { EqlField, EqlFieldValueType } from 'generated/graphql';
import { NormalisedFilter } from 'v2/querybuilder/types/querystore';

export function getFilterValueType(
  eqlField: EqlField,
): NormalisedFilter['value']['type'] {
  switch (eqlField.valueType) {
    case EqlFieldValueType.Boolean:
      return eqlField.isMultiValue ? 'boolean[]' : 'boolean';
    case EqlFieldValueType.Number:
      return eqlField.isMultiValue ? 'number[]' : 'number';
    default:
      return eqlField.isMultiValue ? 'string[]' : 'string';
  }
}
